// ========================================================================
// This file is auto-generated by the `yarn naptime:types` script
// ========================================================================
import NaptimeResource from 'bundles/naptimejs/resources/NaptimeResource';

// ========================================================================
// Definitions for resource data types
// ========================================================================

export type CoursesRemainingReason =
  | 'PROGRAM_COURSES_PER_USER_LIMIT'
  | 'CONTRACT_COURSES_PER_USER_LIMIT'
  | 'ENROLLMENT_CAP_LIMIT';

export interface ProgramUserCreditsV1 {
  id: string;
  userId: number;
  programId: string;
  isLimited: boolean;
  totalAllocatedCourses?: number | null;
  coursesRemaining?: number | null;
  coursesRemainingReason?: CoursesRemainingReason | null;
  availableContracts: Array<string>;
}

// ========================================================================
// Definitions for naptime-link
// ========================================================================

export interface ProgramUserCreditsV1Connection {
  elements: Array<ProgramUserCreditsV1> | null;
}

// ========================================================================
// Definitions for naptime-link queries
// ========================================================================

export interface ProgramUserCreditsV1GetQuery {
  ProgramUserCreditsV1: {
    get: ProgramUserCreditsV1Connection | null;
  } | null;
}

export interface ProgramUserCreditsV1GetQueryVariables {
  id: string;
  includes?: string | null;
}

export interface ProgramUserCreditsV1MultiGetQuery {
  ProgramUserCreditsV1: {
    multiGet: ProgramUserCreditsV1Connection | null;
  } | null;
}

export interface ProgramUserCreditsV1MultiGetQueryVariables {
  ids: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-js
// ========================================================================

// Recursively applies Partial<T> to supported culling by the `fields` param.
type PartialConstruction<T> = {
  [TKey in keyof T]?: T[TKey] extends Array<infer TElement>
    ? Array<PartialConstruction<TElement>>
    : T[TKey] extends object
    ? PartialConstruction<T[TKey]>
    : T[TKey];
};

export class ProgramUserCreditsV1NaptimeResource extends NaptimeResource {
  static RESOURCE_NAME = 'programUserCredits.v1' as const;

  declare id: string;

  declare userId: number;

  declare programId: string;

  declare isLimited: boolean;

  declare totalAllocatedCourses?: number | null;

  declare coursesRemaining?: number | null;

  declare coursesRemainingReason?: CoursesRemainingReason | null;

  declare availableContracts: Array<string>;

  // Intentionally "useless" to supply params type
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(params: PartialConstruction<ProgramUserCreditsV1>) {
    super(params);
  }
}
